import { render } from "./ExaminationScheduleView.vue?vue&type=template&id=5b91a219&ts=true"
import script from "./ExaminationScheduleView.vue?vue&type=script&lang=ts"
export * from "./ExaminationScheduleView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__